import { markRaw } from "vue";

import IconBank from "@/components/icons/tabs/IconBank.vue";
import IconBriefcase from "@/components/icons/tabs/IconBriefcase.vue";
import IconBusiness from "@/components/icons/tabs/IconBusiness.vue";
import IconChat from "@/components/icons/tabs/IconChat.vue";
import IconCheckboard from "@/components/icons/tabs/IconCheckboard.vue";
import IconCreditCard from "@/components/icons/tabs/IconCreditCard.vue";
import IconDocument from "@/components/icons/tabs/IconDocument.vue";
import IconDollar from "@/components/icons/tabs/IconDollar.vue";
import IconGroup from "@/components/icons/tabs/IconGroup.vue";
import IconHandshake from "@/components/icons/tabs/IconHandshake.vue";
import IconHouse from "@/components/icons/tabs/IconHouse.vue";
import IconLayout from "@/components/icons/tabs/IconLayout.vue";
import IconLeter from "@/components/icons/tabs/IconLeter.vue";
import IconLogout from "@/components/icons/tabs/IconLogout.vue";
import IconPiechart from "@/components/icons/tabs/IconPiechart.vue";
import IconProfile from "@/components/icons/IconProfile.vue";
import IconQuestionmark from "@/components/icons/tabs/IconQuestionmark.vue";
import IconWallet from "@/components/icons/tabs/IconWallet.vue";
import IconWeight from "@/components/icons/tabs/IconWeight.vue";
import IconUser from "@/components/icons/tabs/IconUser.vue";

export default {
  bank: markRaw(IconBank),
  briefcase: markRaw(IconBriefcase),
  business: markRaw(IconBusiness),
  business_loans: markRaw(IconBusiness),
  chat: markRaw(IconChat),
  checkboard: markRaw(IconCheckboard),
  credit_card: markRaw(IconCreditCard),
  document: markRaw(IconDocument),
  documents: markRaw(IconDocument),
  dollar: markRaw(IconDollar),
  faq: markRaw(IconQuestionmark),
  group: markRaw(IconGroup),
  handshake: markRaw(IconHandshake),
  house: markRaw(IconHouse),
  layout: markRaw(IconLayout),
  letter: markRaw(IconLeter),
  logout: markRaw(IconLogout),
  piechart: markRaw(IconPiechart),
  profile: markRaw(IconProfile),
  questionmark: markRaw(IconQuestionmark),
  user: markRaw(IconUser),
  wallet: markRaw(IconWallet),
  weight: markRaw(IconWeight),
} as const;
